import React from 'react';
import CommonPortfilo from './CommonPortfilo';

const Portfilo = () => {
  return (
    <div>
      <CommonPortfilo items={8} condition={false} />
    </div>
  );
};

export default Portfilo;
